@if (!isLoading && consolidateForm) {
  <div class="container period-selection-container" [formGroup]="consolidateForm">
    <div class="row">
      <div class="col col-12">
        <p class="consolidate-periods-form-header">Select which periods to consolidate</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-12" [ngClass]="{'danger-border is-invalid': isControlInvalid('selectedPeriodIndices')}">
        <app-popover-menu-multi-select
          [multiSelectOptions]="multiSelectPeriodOptions"
          [buttonText]="multiSelectButtonText"
          (selectOrDeselectAll)="selectOrDeselectAll()"
        ></app-popover-menu-multi-select>
        @if (isControlInvalid('selectedPeriodIndices')) {
          <div class="invalid-feedback">Please select at least one period.</div>
        }
      </div>
    </div>
    <div class="row">
      <div class="col col-12">
        <p class="add-consolidated-period-information-text">Add consolidated period information</p>
      </div>
    </div>
    <div class="row">
      <div class="col col-6 reporting-interval-select" [ngClass]="{'danger-border is-invalid': isControlInvalid('reportingInterval')}">
        <label for="reportingInterval">Select Reporting Interval</label>
        <app-select2
          id="reportingIntervalSelect"
          placeholder="Select"
          [data]="reportingIntervalOptions"
          [options]="{minimumResultsForSearch: -1}"
          [value]="reportingInterval"
          (valueChanged)="updateReportingInterval($event.value)"
          [width]="'100%'"
          >
        </app-select2>
        @if (isControlInvalid('reportingInterval')) {
          <div class="invalid-feedback">Please select a Reporting Interval.</div>
        }
      </div>
      <div class="col col-6 statement-date-select" [ngClass]="{'danger-border is-invalid': isControlInvalid('statementDate')}">
        <label for="statementDate">Select Statement Date</label>
        <app-input-calendar-component
          [initialDate]="statementDate"
          (dateEmitter)="updateStatementDate($event)"
        ></app-input-calendar-component>
        @if (isControlInvalid('statementDate')) {
          <div class="invalid-feedback">Please select a Statement Date.</div>
        }
      </div>
    </div>
    <div class="row">
      <div class="col col-6 balance-sheet-select" [ngClass]="{'danger-border is-invalid': isControlInvalid('balanceSheetFrameIndex')}">
        <label for="balanceSheetFrameSelect">Select Balance Sheet Period</label>
        <app-select2
          id="balanceSheetFrameSelect"
          placeholder="Select"
          [data]="periodOptions"
          [options]="{minimumResultsForSearch: -1}"
          [value]="selectedBalanceSheetFrameIndex"
          (valueChanged)="updateSelectedBalanceSheetFrameIndex($event.value)"
          [width]="'100%'"
          >
        </app-select2>
        @if (isControlInvalid('balanceSheetFrameIndex')) {
          <div class="invalid-feedback">Please select a Balance Sheet Period.</div>
        }
      </div>
      <div class= "col col-6 currency-select">
        <label for="currencySelect">Select Currency</label>
        <span class="ps-2">
          <i class="fas fa-circle-question" data-bs-toggle="tooltip" data-bs-placement="top"
            title="Use this to select the currency for this built statement. Note: Currencies will not be converted. If consolidating
            statements in different currencies but choosing one currency (e.g., USD), amounts will be totaled without conversion."></i>
        </span>
        <select class="form-select" (change)="changeCurrency($event.target.value)">
          @for (currencyOption of supportedCurrencies; track currencyOption) {
            <option [value]="currencyOption.key"
              [selected]="currencyOption.key === currency">
              {{currencyOption.key}} ({{currencyOption.symbol}})
            </option>
          }
        </select>
      </div>
    </div>
    @if (isBeginningCashInTable) {
      <div class="row">
        <div class="col col-12" [ngClass]="{'danger-border is-invalid': isControlInvalid('beginningCashFrameIndex')}">
          <label for="beginningCashFrameSelect">Select Beginning Cash Period</label>
          <app-select2
            id="beginningCashFrameSelect"
            placeholder="Select"
            [data]="periodOptions"
            [options]="{minimumResultsForSearch: -1}"
            [value]="selectedBeginningCashFrameIndex"
            (valueChanged)="updateSelectedBeginningCashFrameIndex($event.value)"
            [width]="'100%'"
            >
          </app-select2>
          @if (isControlInvalid('beginningCashFrameIndex')) {
            <div class="invalid-feedback">Please select a Beginning Cash Period.</div>
          }
        </div>
      </div>
    }
    <div class="row">
      <div class="col col-6 balance-sheet-select" [ngClass]="{'danger-border is-invalid': isControlInvalid('scenarioType')}">
        <label for="scenarioTypeSelect">Scenario Type</label>
        <app-select2
          id="scenarioTypeSelect"
          placeholder="Select"
          [data]="availableScenarioTypeOptions"
          [options]="{minimumResultsForSearch: -1}"
          [value]="scenarioType"
          (valueChanged)="updateScenarioType($event.value)"
          [width]="'100%'"
        ></app-select2>
        @if (isControlInvalid('scenarioType')) {
          <div class="invalid-feedback">Please select a Scenario Type.</div>
        }
      </div>
      <div class="col col-6 currency-select">
        <label for="scenarioNameInput">Scenario Name</label>
        <input
          id="scenarioNameInput"
          type="text"
          class="form-control"
          [class.is-invalid]="isControlInvalid('scenarioName')"
          placeholder="Scenario Name"
          formControlName="scenarioName"
        />
        @if (isControlInvalid('scenarioName')) {
          <div class="invalid-feedback">{{ getScenarioNameError() }}</div>
        }
      </div>
    </div>
    <div class="row">
      @if (isEndingCashInTable) {
        <div class="col col-12" [ngClass]="{'danger-border is-invalid': isControlInvalid('endingCashFrameIndex')}">
          <label for="endingCashFrameSelect">Select Ending Cash Period</label>
          <app-select2
            id="endingCashFrameSelect"
            placeholder="Select"
            [data]="periodOptions"
            [options]="{minimumResultsForSearch: -1}"
            [value]="selectedEndingCashFrameIndex"
            (valueChanged)="updateSelectedEndingCashFrameIndex($event.value)"
            [width]="'100%'"
            >
          </app-select2>
          @if (isControlInvalid('endingCashFrameIndex')) {
            <div class="invalid-feedback">Please select an Ending Cash Period.</div>
          }
        </div>
      }
    </div>
    <div class="footer">
      @if (buildAttempted && consolidateForm.invalid) {
        <span class="footer-validation-message">Please resolve error(s)</span>
      }
      <div class="footer-buttons">
        <button class="btn btn-link" (click)="triggerCloseConsolidatePeriods()">Cancel</button>
        <button class="btn btn-primary" (click)="generateConsolidatedStatement()" [disabled]="isSubmitting">
          <span class="build-statement-btn-label">Build Statement</span>
          @if (isSubmitting) {
            <div class="loader button-loader build-statement-btn-icon"></div>
          }
        </button>
      </div>
    </div>
  </div>
} @else {
  <div class="loading-panel-container loader__container">
    <div class="loader"></div>
  </div>
}

